<template>
  <v-container>
    <div class="flex space-x-2.5">
      <div>

        <v-autocomplete outlined dense label="Store" :items="branchList" @change="onStoreKeyup" item-text="name"
          item-value="id"></v-autocomplete>
      </div>
      <div>
        <v-text-field outlined dense label="Search" append-icon="mdi-magnify" @keyup="onSearchChange"
          clearable></v-text-field>
      </div>
    </div>
    <v-data-table :options.sync="tableOptions" :headers="headers" :items="userList" :loading="userFetching"
      :sort-by="['store_name']" :server-items-length="userCount">
      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active" class="green--text">mdi-check</v-icon>
        <v-icon v-else class="red--text">mdi-close</v-icon>
      </template>
      <template v-slot:item.config="{ item }">
        <td>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="purple" text v-bind="attrs" v-on="on" small @click="editUserRole(item)">
                <v-icon>mdi-account-child-outline</v-icon>
              </v-btn>
              <v-btn color="yellow darken-3" text v-bind="attrs" v-on="on" small @click="initEdit(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:item.updated_at="{ value }">
        {{ getCurrentDateEnUsFormat(new Date(value)) }}
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import appAxios from '../../../../../../extra-functions/axios.extra'
import { getCurrentDateEnUsFormat, useDebounce } from '../../../../../../lib/utils'

const searchKeyupDebounce = useDebounce()

export default {
  name: 'vIndexUser',
  data() {
    return {
      headers: [
        {
          text: 'Store',
          value: 'store_name',
          sortable: true,
        },
        { sortable: true, text: 'Name', value: 'name' },
        { sortable: true, text: 'Username', value: 'username' },
        { sortable: false, text: 'Active', value: 'active' },
        { sortable: false, text: 'Role', value: 'role' },
        { sortable: false, text: 'Updated', value: 'updated_at' },
        { sortable: false, text: 'Config', value: 'config' },
      ],
      tableOptions: {},
      userList: [],
      userFetching: false,
      userCount: 0,
    }
  },
  computed: {
    ...mapState({
      branchList: state => state.branchLocation.list,
      authToken: state => state.auth.token,
    }),
  },
  watch: {
    tableOptions() {
      this.$emit('refetch')
    },
  },
  methods: {
    initEdit(item) {
      this.$emit('edit', item)
    },
    /**
     * Description
     * @param {AbortController} [controller]
     * @returns {any}
     */
    async fetchUsers(controller) {
      try {
        this.userFetching = true
        const params = { ...this.tableOptions }
        const { data } = await appAxios(this.authToken).get('/admin/users/index-v2', { params, signal: controller?.signal })
        this.userList = data.list ?? []
        this.userCount = data.count ?? 0
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong')
      } finally {
        this.userFetching = false
      }
    },
    dateFormat(dateInput) {
      const date = new Date(dateInput)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')

      return `${month}/${day}/${year}`
    },
    onStoreKeyup(storeId) {
      this.tableOptions = {
        ...this.tableOptions,
        storeId,
      }
    },
    editUserRole(item) {
      this.$emit('edit-role', item)
    },
    onSearchChange(e) {
      const { value: search } = e.target
      searchKeyupDebounce(() => {
        this.tableOptions = { ...this.tableOptions, search }
      })
    },
    getCurrentDateEnUsFormat,
  },
}
</script>
